<div>
  <textarea #textarea
            class="app-textarea body-md-regular"
            [class.input-invalid]="invalid()"
            [attr.id]="inputId() || null"
            [attr.maxlength]="maxLength()"
            [rows]="rows()"
            [placeholder]="placeholder()"
            [disabled]="disabled()"
            [value]="value()"
            (input)="handleInput($event)"
            (blur)="handleBlur()"
            [attr.data-testid]="testId()"></textarea>

  @if (quickTapOptions().length) {
    <div class="app-textarea-quick-taps"
         role="group"
         aria-label="Quick note presets">
      @for (option of quickTapOptions(); track $index) {
        <button pButton
                type="button"
                class="bqa-quick-tap-btn"
                [rounded]="true"
                severity="secondary"
                [disabled]="disabled() || value().length + quickTapText(option, textarea).length > maxLength()"
                (pointerdown)="$event.preventDefault()"
                (click)="insertQuickTap(option, textarea)">{{ option }}</button>
      }
    </div>
  }
</div>

@if (showCount()) {
  <div class="app-textarea-footer">
    <app-character-count class="app-textarea-count"
                         [current]="value().length"
                         [max]="maxLength()" />
  </div>
}
